import { Trans } from "@lingui/macro"
import { Button, ElevatedSectionContainer, useSticky } from "@silversea-ssc/ui-components-react"
import React, { useCallback, useRef } from "react"
import clsx from "clsx"
import useModal from "../../../components/ModalProvider/useModal"
import { VisibleMobile, VisibleTabletUp } from "../../../components/ResponsiveComponents"
import styles from "./SuitesComparisonBox.module.scss"

const SuitesComparisonBox = () => {
    const { openModal } = useModal()
    const rootEl = useRef<HTMLDivElement>(null)
    const isSticky = useSticky(rootEl, 0)

    const openComparison = useCallback(() => openModal({ modalType: "suites-comparison" }), [openModal])
    const containerCSS = clsx(styles.container, { [styles.isSticky]: isSticky })

    // TODO - suites-comparison: try to check how to get this state
    const isDisabled = false
    return (
        <div className={styles.root} ref={rootEl}>
            <ElevatedSectionContainer
                containerClassName={containerCSS}
                dataContentName="suites-comparison-box"
                topBackgroundColor="white"
                bottomBackgroundColor="white"
                fixed={false}
            >
                <VisibleMobile>
                    <SuitesComparisonBoxMobile disabled={isDisabled} openComparison={openComparison} />
                </VisibleMobile>
                <VisibleTabletUp>
                    <SuitesComparisonBoxDesktop disabled={isDisabled} openComparison={openComparison} />
                </VisibleTabletUp>
            </ElevatedSectionContainer>
        </div>
    )
}

type SuitesComparisonBoxResponsiveProps = {
    disabled: boolean
    openComparison: () => void
}

const SuitesComparisonBoxMobile: React.FC<React.PropsWithChildren<SuitesComparisonBoxResponsiveProps>> = ({
    disabled,
    openComparison,
}) => {
    return (
        <div className={styles.wrapper}>
            <Button
                dataContentPiece="open-suites-comparison"
                variant="secondary"
                renderAs="button"
                iconName="open-tab"
                onClick={openComparison}
                disabled={disabled}
                full
            >
                <Trans>Compare categories</Trans>
            </Button>
        </div>
    )
}

const SuitesComparisonBoxDesktop: React.FC<React.PropsWithChildren<SuitesComparisonBoxResponsiveProps>> = ({
    disabled,
    openComparison,
}) => {
    return (
        <div className={styles.wrapperDesktop}>
            <span>
                <Trans>
                    Want to know more about <strong>differences between suite categories?</strong>
                </Trans>
            </span>
            <Button
                dataContentPiece="open-suites-comparison"
                variant="inline-text"
                renderAs="button"
                onClick={openComparison}
                disabled={disabled}
            >
                <Trans>Compare categories</Trans>
            </Button>
        </div>
    )
}

export default SuitesComparisonBox
